import React, { useState } from "react";
import { Loader2, ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";

/** One-click Safe Sources Pack for a single site (dry-run preview → apply). */
export default function SafePackButton({ siteId, onDone }) {
  const [disableRisky, setDisableRisky] = useState(true);
  const [plan, setPlan] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  async function run(dryRun) {
    setBusy(true); setMsg("");
    try {
      const r = await api.post("/sources/safe-pack", { site_id: siteId, disable_risky: disableRisky, dry_run: dryRun });
      if (dryRun) setPlan(r.data);
      else { setPlan(null); setMsg(`Added ${r.data.added} · re-enabled ${r.data.re_enabled} · disabled ${r.data.disabled}`); onDone && onDone(); }
    } catch (e) { setMsg(e.response?.data?.detail || e.message); }
    finally { setBusy(false); }
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-3 flex-wrap">
        <button type="button" data-testid="safe-pack-preview" disabled={busy} onClick={() => run(true)} className="px-2.5 py-1 text-[11px] font-semibold border border-emerald-500/40 bg-emerald-500/10 text-emerald-200 hover:bg-emerald-500/20 rounded-sm flex items-center gap-1.5 disabled:opacity-50">
          {busy ? <Loader2 size={11} className="animate-spin" /> : <ShieldCheck size={11} />} Add safe pack…
        </button>
        <label className="text-[11px] text-zinc-400 flex items-center gap-1.5 cursor-pointer">
          <input type="checkbox" data-testid="safe-pack-disable-risky" checked={disableRisky} onChange={(e) => setDisableRisky(e.target.checked)} /> disable publisher © feeds
        </label>
        {msg && <span data-testid="safe-pack-msg" className="text-[11px] mono text-emerald-300">{msg}</span>}
      </div>
      {plan && (
        <div data-testid="safe-pack-plan" className="border border-zinc-800 rounded-sm p-3 text-xs space-y-2">
          <div className="text-zinc-200">Will add <span className="mono text-emerald-300">{plan.added}</span> feed(s){plan.re_enabled ? `, re-enable ${plan.re_enabled}` : ""}{disableRisky ? <> and disable <span className="mono text-amber-300">{plan.disabled}</span> publisher feed(s)</> : null}.</div>
          {plan.disabled_names?.length > 0 && <div className="text-[11px] text-amber-400 mono truncate">off: {plan.disabled_names.join(" · ")}</div>}
          <div className="flex gap-2">
            <button type="button" data-testid="safe-pack-apply" disabled={busy || (!plan.added && !plan.disabled && !plan.re_enabled)} onClick={() => run(false)} className="px-3 py-1.5 text-xs font-semibold bg-white text-zinc-950 hover:bg-zinc-200 disabled:opacity-40 rounded-sm">Apply</button>
            <button type="button" onClick={() => setPlan(null)} className="px-3 py-1.5 text-xs border border-zinc-800 rounded-sm text-zinc-400">Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
}
